import { Record } from 'immutable';

const LookupAddressRecord = Record({
  line1: null,
  line2: null,
  line3: null,
  countryCode: null,
  city: null,
  state: null,
  postalCode: null
});

export class LookupAddress extends LookupAddressRecord {
  line1: string;
  line2: string;
  line3: string;
  countryCode: string;
  city: string;
  state: string;
  postalCode: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/lookup-address.ts